import React from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { fetchDriverFeatures, fetchDriverOpmodes, fetchDriverCount, fetchDriverOpmodesSelected, fetchDriverProperties, retrieveLuminaireImageProject, uploadLuminaireImageProject, fetchDriverProgrammingSelection, updateDriverProgrammingSingleSelection, updateDriver } from '../../../../../actions';
import ProjectFeatureList from './ProjectFeatureList';
import ProjectFeature from './ProjectFeature';
import ProjectInfo from './ProjectInfo';
import { insertPropertiesInFeatures } from '../../../../../utils/driverUtils';
import { ASTRO_DIM_5, ASTRO_DIM_SENSOR } from '../../../../../utils/constantFeatures';

class ProjectDriver extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showedFeature: null,
            checkedFeatures: null,
            features: null,
            driver: null,
            selectedDriverId: null,
            project: null,
            driverProperties: null,
            isShowingDriverAdd: false,
            isTW: true,
            opModeName: null
        };

        this.onCheckFeature = this.onCheckFeature.bind(this);
        this.onShowFeature = this.onShowFeature.bind(this);
        this.handleChangeProjectInfo = this.handleChangeProjectInfo.bind(this);
        this.handleChangeOperatingMode = this.handleChangeOperatingMode.bind(this);
        this.handleChangeLuminaireImage = this.handleChangeLuminaireImage.bind(this);
    }

    componentDidMount() {

        if (this.props.driver) {
            this.fetchDataFromDriver();
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if(this.props.opmodesSelected && this.state.opModeName === null){
            this.setState({ isTW: this.props.opmodesSelected.name === 'dali8tw' || this.props.opmodesSelected.name === 'td_d2w' || this.props.opmodesSelected.name === 'td_tw' });
            this.setState({ opModeName: this.props.opmodesSelected.name });
            // this.props.handleChangeOperatingMode(this.props.opmodesSelected);
        }

        if(prevProps.driverId !== this.props.driverId) {
            this.props.updateDriver(this.props.drivers[this.props.driverId]);
        }

        if (this.props.driver && this.props.driver !== prevProps.driver) {
            this.fetchDataFromDriver();
        }

        if (this.props.programmingSelection !== prevState.checkedFeatures) {
            this.setState({ checkedFeatures: this.props.programmingSelection });
        }

        if (this.props.driverFeatures && this.props.driverFeatures !== prevProps.driverFeatures) {
            //Autoselect the first feature when operating mode change
            this.setState({ showedFeature: this.getDefaultShownFeature(this.props.driverFeatures) });
        }
    }

    getDefaultShownFeature(driverFeatures) {
        // In astdimsens mode, ast5 is hidden from the feature list (AstroDimSensor already
        // covers its schedule) - don't autoselect it just because it's listed first.
        const hasSensorCombo = driverFeatures.some(f => f.name === ASTRO_DIM_SENSOR.shortName);
        const candidates = hasSensorCombo
            ? driverFeatures.filter(f => f.name !== ASTRO_DIM_5.shortName)
            : driverFeatures;
        return candidates[0];
    }

    fetchDataFromDriver() {
        this.props.fetchDriverFeatures(this.props.project.id, this.props.driver.driverId)
            .then(() => {
                this.setState({ showedFeature: this.getDefaultShownFeature(this.props.driverFeatures) });
            });
        this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);
        this.props.fetchDriverOpmodes(this.props.project.id, this.props.driver.driverId);
        this.props.fetchDriverCount(this.props.project.id, this.props.driver.driverId);

        this.props.fetchDriverOpmodesSelected(this.props.project.id, this.props.driver.driverId)
            .then(() => {
                this.props.handleChangeOperatingMode(this.props.opmodesSelected);
            });

        this.props.fetchDriverProgrammingSelection(this.props.project.id, this.props.driver.driverId);
    }

    static getDerivedStateFromProps(props, state) {

        const newState = {};

        if (props.driver && !state.driver) {
            newState.driver = Object.assign({}, props.driver);
        }

        if (props.project && !state.project) {
            newState.project = Object.assign({}, props.project);
        }

        if (props.driverFeatures && props.driverProperties) {
            newState.driverFeatureWithProperties = insertPropertiesInFeatures(props.driverFeatures, props.driverProperties);
        }

        if (props.programmingSelection && props.programmingSelection !== state.checkedFeatures) {
            newState.checkedFeatures = props.programmingSelection;
        }

        // nextProps and prevState
        if(props.driverId !== state.driverId) {
            newState.selectedDriverId = props.driverId;
        }

        if (Object.keys(newState).length > 0) {
            return newState;
        }

        return null;
    }

    handleChangeLuminaireImage(e) {

        const files = Array.from(e.target.files);

        if (files.length !== 1) {
            return;
        }

        this.props.uploadLuminaireImageProject(this.props.project.id, files[0])
            .then((id) => {
                document.getElementById("projectImageInput").value = null;

                this.props.retrieveLuminaireImageProject(this.props.project.id)
                    .then(() => {
                        var reader = new FileReader();
                        reader.readAsDataURL(this.props.luminaireImage);
                        reader.onloadend = function () {
                            var base64data = reader.result.replace("application/octet-stream", "image/png");
                            document.getElementById("projectImage").src = base64data;
                        }
                    });

            });
    }

    handleChangeProjectInfo(event) {

        let prop = this.state[event.target.name];
        prop[event.target.id] = event.target.value;
        this.setState({ [event.target.name]: prop });

        this.props.handleChangeProjectInfo(event);
    }

    handleChangeOperatingMode(event) {

        let opModeSelect = null;

        for (let i = 0; i < this.props.opmodes.length; i++) {
            if (this.props.opmodes[i].id === parseInt(event.target.value)) {
                opModeSelect = this.props.opmodes[i];
                break;
            }
        }

        this.setState({ isTW: opModeSelect.name === 'dali8tw' || opModeSelect.name === 'td_d2w' || opModeSelect.name === 'td_tw' });
        this.setState({ opModeName: opModeSelect.name });
        this.props.handleChangeOperatingMode(opModeSelect);
    }

    onShowFeature(e, driverFeature) {

        if (e.target.type === 'checkbox') {
            return;
        }

        e.preventDefault();

        this.setState({
            showedFeature: driverFeature
        });
    }

    onCheckFeature(featureName, value) {

        this.setState((state, props) => {

            const indexOfUnderscore = featureName.indexOf("_");
            const name = indexOfUnderscore >= 0 ? featureName.substring(0, indexOfUnderscore) : featureName;

            let checkedFeatures = state.checkedFeatures;
            if (value === true) {
                if (checkedFeatures.indexOf(name) === -1) {
                    checkedFeatures.push(name);
                }
            } else {
                checkedFeatures.splice(checkedFeatures.indexOf(name), 1);
            }

            this.props.updateDriverProgrammingSingleSelection(this.props.project.id, this.props.driver.driverId, name, value)
                .then(() => {
                    this.props.fetchDriverProgrammingSelection(this.props.project.id, this.props.driver.driverId);
                    // this.props.verifyProject(this.props.project.id);
                });

            this.props.handleCheckedFeatures(checkedFeatures);

            return {
                checkedFeatures,
            };
        });
    }

    render() {

        if (this.props.match.params.driverId === undefined && this.props.driver) {
            return <Redirect to={'/projects/' + this.props.project.id + '/driver/' + this.props.driver.driverId} />;
        }

        return (
            <div>
                <Row className="row-project-info">
                    <Col sm={12}>
                        <ProjectInfo
                            project={this.props.project}
                            opmodes={this.props.opmodes}

                            driver={this.props.driver}
                            drivers={this.props.drivers}
                            driverFeatures={this.props.driverFeatures}
                            driverProperties={this.props.driverProperties}

                            disabled={this.props.disabledDriver}
                            opmodesSelected={this.props.opmodesSelected}
                            openAddDriver={this.props.openAddDriver}
                            errors={this.props.projectErrors}

                            projectName={this.props.projectName}
                            projectOrderCode={this.props.projectOrderCode}
                            projectDescription={this.props.projectDescription}
                            projectCustomer={this.props.projectCustomer}
                            handleChangeProjectInfo={this.props.handleChangeProjectInfo}

                            handleChangeDriverProperties={this.props.handleChangeDriverProperties.bind(this)}

                            handleChange={this.handleChangeProjectInfo}
                            handleChangeOperatingMode={this.handleChangeOperatingMode}
                            handleChangeLuminaireImage={this.handleChangeLuminaireImage}
                            checkedFeatures={this.state.checkedFeatures}
                            onCheckFeature={this.onCheckFeature} />
                    </Col>
                </Row>
                <Row className="row-project-feature-list">
                    <Col sm={2} style={{ paddingRight: '0' }}>
                        <ProjectFeatureList
                            showedFeature={this.state.showedFeature}
                            checkedFeatures={this.state.checkedFeatures}
                            onShowFeature={this.onShowFeature}
                            onCheckFeature={this.onCheckFeature}
                            driverFeatures={this.props.driverFeatures}
                            driverProperties={this.props.driverProperties}
                            driverFeatureWithProperties={this.state.driverFeatureWithProperties}
                            {...this.props} />
                    </Col>
                    <Col sm={10} style={{ paddingLeft: '0' }} className={this.props.disabledClassName}>
                        <ProjectFeature
                            project={this.props.project}
                            driver={this.props.driver}
                            feature={this.state.showedFeature}
                            driverFeatures={this.props.driverFeatures}
                            properties={this.props.driverProperties}
                            isTW={this.state.isTW}
                            opModeName={this.state.opModeName}
                            handleChangeDriverProperties={this.props.handleChangeDriverProperties.bind(this)} />
                    </Col>
                </Row>
            </div>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        driverFeatures: state.driver.features,
        driverProperties: state.driver.properties,

        opmodes: state.driver.opmodes,
        opmodesSelected: state.driver.opmodesSelected,

        programmingSelection: state.driver.programmingSelection,

        luminaireImage: state.project.luminaireImage
    };
};

const mapDispatchToProps = {
    fetchDriverFeatures,
    fetchDriverOpmodes,
    fetchDriverOpmodesSelected,
    fetchDriverProperties,
    fetchDriverProgrammingSelection,
    fetchDriverCount,
    updateDriverProgrammingSingleSelection,
    uploadLuminaireImageProject,
    retrieveLuminaireImageProject,
    updateDriver
    // verifyProject
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectDriver);
